module.exports = ["akkurat nå",["%s sekund siden","%s sekunder siden"],["%s minutt siden","%s minutter siden"],["%s time siden","%s timer siden"],["%s dag siden","%s dager siden"],["%s uke siden","%s uker siden"],["%s måned siden","%s måneder siden"],["%s år siden","%s år siden"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/nb-NO.json
// module id = 06qg
// module chunks = 1